<div class="w-100 h-100">
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="reload()"></i>
                                {{$t('senderComplaints.senders')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto" v-if="canProcessComplaints">
                            <button class="btn btn-primary btn-action mr-2"
                                    :disabled="isDateRangeInvalid"
                                    @click="exportToExcel">{{$t('shared.exportToExcel')}}</button>
                            <button :disabled="!isAnySelected" class="btn btn-primary btn-action" @click="showReactivateDialog('')">{{$t('senderComplaints.reactivate')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.complaintId"
                                       @keypress="search"
                                       :placeholder="$t('senderComplaints.complaintId')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.senderName"
                                       @keypress="search"
                                       :placeholder="$t('senderComplaints.senderNameSearch')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       @keypress="search"
                                       v-model="filterModel.clientName"
                                       :placeholder="$t('senderComplaints.clientName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       @keypress="search"
                                       v-model="filterModel.providerName"
                                       :placeholder="$t('senderComplaints.providerName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                                <v-select
                                style="width: 100%;"
                                v-model="filterModel.complaintStatus"
                                :items="complaintStatusList"
                                item-text="name"
                                item-value="id"
                                :placeholder="$t('senderComplaints.complaintStatus')"
                                solo
                                dense
                                clearable
                                @change="search"
                                attach>
                              </v-select>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="createdDateFromMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        lazy
                                        full-width
                                        min-width="290px"
                                        offset-y
                                        attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left"
                                                   v-model="filterModel.dateFrom"
                                                   :placeholder="$t('shared.createdDateFrom')"
                                                   readonly
                                                   v-on="on"
                                                   type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateFrom"
                                                   no-title
                                                   scrollable
                                                   @input="onDateChange('from')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="createdDateToMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        lazy
                                        full-width
                                        min-width="290px"
                                        offset-y
                                        attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left"
                                                   v-model="filterModel.dateTo"
                                                   :placeholder="$t('shared.createdDateTo')"
                                                   readonly
                                                   v-on="on"
                                                   type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateTo"
                                                   no-title
                                                   scrollable
                                                   @input="onDateChange('to')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-1 mt-1">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table v-model="selected"
                                      :headers="headers"
                                      :items="senders"
                                      :total-items="sendersCount"
                                      select-all
                                      :pagination.sync="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      item-key="complaintId"
                                      class="elevation-1 table-striped">
                            <template v-slot:headers="props">
                                <tr>
                                    <th v-if="canProcessComplaints">
                                        <v-checkbox :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    primary
                                                    hide-details
                                                    @click.stop="selectAll"></v-checkbox>
                                    </th>
                                    <th v-for="header in props.headers"
                                        :key="header.text"
                                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                        :width="header.width !== ''? header.width : ''">
                                        <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:items="props">
                                <tr>
                                    <td v-if="canProcessComplaints">
                                        <v-checkbox v-model="props.selected"
                                                    @change="select($event, props.item.complaintId)"
                                                    primary
                                                    hide-details></v-checkbox>
                                    </td>
                                    <td class="text-center">{{ props.item.complaintId }}</td>
                                    <td class="text-center">{{ props.item.senderName}}</td>
                                    <td class="text-center">{{ props.item.clientName }}</td>
                                    <td class="text-center">{{ props.item.providerName }}</td>
                                    <td class="text-center">{{ props.item.requestDate }}</td>
                                    <td class="text-center">{{getComplaintStatus(props.item.complaintStatus)}}</td>
                                    <td class="text-center">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="status_txt" :class="'status-' + props.item.senderStatus">{{GetSenderStatus(props.item.senderStatus)}}</div>
                                            <Progress :radius="10" :strokeColor="checkColor(props.item.senderStatus)" :strokeWidth="5" :value="100">
                                                <div class="content"></div>
                                                <template v-slot:footer>
                                                    <b></b>
                                                </template>
                                            </Progress>
                                            <div class="days_left">
                                                {{props.item.remainingDays}} {{$t('dashboardPage.of')}} {{props.item.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center btn_menu">
                                        <template>
                                            <v-menu offset-y open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn color="btn-primary"
                                                           v-on="on">
                                                        <div>{{$t('shared.actions')}}</div>
                                                        <i class="fas fa-chevron-down pl-4" style="vertical-align: sub;"></i>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile v-if="props.item.complaintStatus == 2 && props.item.senderStatus == 4 && canProcessComplaints"
                                                                 @click="showReactivateDialog(props.item.complaintId)">
                                                        <v-list-tile-title class="white">{{$t('senderComplaints.reactivate')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="props.item.complaintStatus == 1 &&  canProcessComplaints &&(props.item.senderStatus == 7 ||props.item.senderStatus == 5)"
                                                                 @click="showCloseComplaintDialog(props.item.complaintId)">
                                                        <v-list-tile-title class="white">{{$t('senderComplaints.closeComplaint')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile v-if="props.item.complaintStatus == 1 &&  canProcessComplaints &&(props.item.senderStatus == 7 ||props.item.senderStatus == 5)"
                                                                 @click="showDeactivateComplaintDialog(props.item.complaintId)">
                                                        <v-list-tile-title class="white">{{$t('senderComplaints.deactivate')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="Details(props.item.complaintId)">
                                                        <v-list-tile-title class="white">{{$t('senderComplaints.details')}}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="reactivateDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.reactivateInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideReactivateDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.reactivateInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideReactivateDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="Reactivate">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="closeComplaintDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('senderComplaints.closeComplaint')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideCloseComplaintDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('senderComplaints.closeComplaintInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideCloseComplaintDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="closeComplaint()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deactivateComplaintDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('senderComplaints.deactivateComplaint')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeactivateComplaintDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('senderComplaints.deactivateComplaintInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeactivateComplaintDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deactivateComplaint()">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</div>